/* eslint-disable react/display-name */
import { FieldTypes } from "@/api/AppApi/services/builder/interfaces/interfaces";
import { forwardRef } from "react";
import RequiredStar from "@/app/components/lib/RequiredStar";
import InputErrorMsg from "../../../form-builder-helpers/InputErrorMsg";


interface Props {
  label: string;
  value?: any;
  type?: FieldTypes;
  dir?: "ltr" | "rtl" | "auto";
  errorMsg?: string;
  onClick?: () => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isRequired: boolean;
  hideLabel?: boolean;
  hint?: string;
}

const FloatingInput = forwardRef<HTMLInputElement, Props>(
  (
    {
      value,
      onClick,
      isRequired,
      onChange,
      label,
      type = FieldTypes.text, // Default to text
      dir = "auto",
      errorMsg,
      hideLabel,
      hint,
    },
    ref,
  ) => {
    // Map FieldTypes to HTML input types
    let inputType = "text";
    switch (type) {
      case FieldTypes.date:
        inputType = "date";
        break;
      case FieldTypes.time:
        inputType = "time";
        break;
      case FieldTypes.date_time:
        inputType = "datetime-local";
        break;
      case FieldTypes.email:
        inputType = "email";
        break;
      case FieldTypes.password:
        inputType = "password";
        break;
      case FieldTypes.number:
        inputType = "number";
        break;
        case FieldTypes.mobile:
        case FieldTypes.phone:
            inputType = "tel";
            break;
      default:
        inputType = "text";
    }

    return (
      <>
        <div className="form-floating mb-3">
          <input
            className="form-control"
            id="floatingInput"
            readOnly={!!onClick} 
            onClick={onClick}
            onChange={onChange}
            value={value}
            ref={ref}
            placeholder={label}
            dir={dir}
            type={inputType}
            autoComplete="new-password"
          />
          <label htmlFor="floatingInput">
            {!hideLabel && (
              <span>
                <RequiredStar title={label} isRequired={isRequired} />
              </span>
            )}
          </label>
          {hint && <div className="field-hint">{hint}</div>}
          {errorMsg && <InputErrorMsg errorMsg={errorMsg} />}
        </div>
      </>
    );
  },
);

export default FloatingInput;
